import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import makeComponentTrashable, { TrashableProps } from 'trashable-react';
import { TICKET_ACTIONS } from '../../actions/ticket';
import { apiRequest } from '../../APIClient';
import { ROUTE_PATH } from '../../constants';
import { sessionSelector } from '../../reducers/session';
import { Dispatch, OBTeamContacts, TeamMemberType } from '../../types';
import { BareContact } from './Contact';
import { MessageBody } from './MessageForm';
import { onboardingSelector } from '../../reducers/onboarding';
import { TicketDetail } from '../../types/tickets';

export const SHARE_LINK_TICKET_TYPE = 'request__portal';

type OwnProps = TrashableProps &
  RouteComponentProps<{}, {}, { link?: string; subject?: string }>;

export type StoreProps = {
  cst: Array<TeamMemberType>;
  isOnboarding: boolean;
  onboardingTeamContacts: OBTeamContacts;
};

export type DispatchProps = {
  setTicketFilters: (arg0: URLSearchParams) => void;
  onCreateTicket: (arg0: MessageBody) => Promise<TicketDetail>;
  fetchOnboardingTeamContacts: () => void;
};

export type Props = OwnProps & StoreProps & DispatchProps;

class ShareView extends React.Component<Props> {
  onCreateTicket = (message: MessageBody) => {
    // inject link into ticket description and add an internal note
    const ticket: MessageBody = { ...message };
    const { link, description } = message;
    if (link) {
      ticket.description = `\n> Shared Link: [${link}](${link})\n\n${description}`;
    }
    return this.props.onCreateTicket(ticket);
  };

  render() {
    const {
      cst,
      history,
      registerPromise,
      setTicketFilters,
      isOnboarding,
      onboardingTeamContacts,
      fetchOnboardingTeamContacts,
    } = this.props;

    let { link, subject } = history.location?.state ?? {};
    if (link || subject) {
      return (
        <BareContact
          cst={cst}
          history={history}
          initialSubject={subject}
          link={link}
          onCreateTicket={this.onCreateTicket}
          registerPromise={registerPromise}
          setTicketFilters={setTicketFilters}
          showOnboarding={isOnboarding}
          onboardingTeamContacts={onboardingTeamContacts}
          fetchOnboardingTeamContacts={fetchOnboardingTeamContacts}
        />
      );
    } else {
      return <Redirect to={ROUTE_PATH.CONTACT} />;
    }
  }
}

export default connect<StoreProps, DispatchProps, OwnProps>(
  (store): StoreProps => ({
    cst: sessionSelector.getCST(store),
    isOnboarding: sessionSelector.isCustomerOnboarding(store),
    onboardingTeamContacts: onboardingSelector.getOnboardingTeamContacts(store),
  }),
  (dispatch: Dispatch): DispatchProps => ({
    setTicketFilters: (filter: URLSearchParams) =>
      dispatch(TICKET_ACTIONS.SET_FILTERS(filter)),
    onCreateTicket: (message: MessageBody) => {
      return dispatch(
        apiRequest.createTicket(
          message.subject,
          message.description,
          message.attachmentTokens,
          SHARE_LINK_TICKET_TYPE,
          message.link,
        ),
      );
    },
    fetchOnboardingTeamContacts: () =>
      dispatch(apiRequest.getOnboardingTeamContacts()),
  }),
)(makeComponentTrashable(ShareView));
